import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { Lock, Mail, Eye, EyeOff, Shield, ArrowLeft } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext'
import toast from 'react-hot-toast'
import '../../styles/AdminLogin.css'

export default function AdminLogin() {
  const navigate = useNavigate()
  const { login } = useAuth()
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  })
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState('')

  const handleLogin = async (e) => {
    e.preventDefault()
    setError('')
    
    if (!credentials.email || !credentials.password) {
      setError('Veuillez remplir tous les champs')
      return
    }

    setLoading(true)
    
    try {
      const result = await login(credentials.email, credentials.password)
      
      if (result.success) {
        toast.success('Connexion réussie !')
        navigate('/admin/dashboard')
      } else {
        setError(result.error || 'Échec de la connexion')
        toast.error(result.error || 'Échec de la connexion')
      }
    } catch (error) {
      console.error('Login error:', error)
      setError('Erreur lors de la connexion')
      toast.error('Erreur lors de la connexion')
    } finally {
      setLoading(false)
    }
  }

  // Fonction de connexion de test pour développement
  const handleTestLogin = () => {
    setCredentials({
      email: 'admin@ultimatag.com',
      password: 'test123'
    })
    
    // Auto-login après 500ms
    setTimeout(() => {
      const formEvent = { preventDefault: () => {} }
      handleLogin(formEvent)
    }, 500)
  }

  return (
    <div className="admin-login-container">
      <div className="login-wrapper">
        <div className="login-header">
          <div className="login-logo">
            <Lock size={32} />
          </div>
          <h1 className="login-title">Connexion Admin</h1>
          <p className="login-subtitle">
            Accédez au panneau d'administration UltimaTag
          </p>
        </div>
        
        <div className="login-card">
          {error && (
            <div className="error-message">
              <Lock size={16} className="error-icon" />
              <span>{error}</span>
            </div>
          )}
          
          <form className="login-form" onSubmit={handleLogin}>
            <div className="form-group">
              <label className="form-label">Email administrateur</label>
              <div className="input-container">
                <Mail size={20} className="form-icon" />
                <input
                  type="email"
                  value={credentials.email}
                  onChange={(e) => setCredentials({...credentials, email: e.target.value})}
                  className="form-input"
                  placeholder="admin@ultimatag.com"
                  required
                />
              </div>
            </div>
            
            <div className="form-group">
              <label className="form-label">Mot de passe</label>
              <div className="input-container">
                <Lock size={20} className="form-icon" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={credentials.password}
                  onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                  className="form-input"
                  placeholder="••••••••"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="password-toggle"
                  aria-label={showPassword ? 'Cacher le mot de passe' : 'Afficher le mot de passe'}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>
            
            <button
              type="submit"
              disabled={loading}
              className="login-button"
            >
              {loading ? (
                <>
                  <div className="spinner-small"></div>
                  Connexion...
                </>
              ) : (
                'Se connecter'
              )}
            </button>
            
            {/* Bouton de test pour développement */}
            {/* <button
              type="button"
              onClick={handleTestLogin}
              style={{
                width: '100%',
                marginTop: '12px',
                padding: '10px',
                backgroundColor: '#00B894',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                cursor: 'pointer'
              }}
            >
              Connexion de test (Développement)
            </button> */}
            
            <Link to="/" className="back-link">
              <ArrowLeft size={16} />
              Retour au site principal
            </Link>
          </form>
        </div>
        
        <div className="support-info">
          <p>
            Pour obtenir un accès administrateur, contactez le support technique.
          </p>
        </div>
        
        <div className="security-badge">
          <Shield size={16} />
          <span>Connexion sécurisée</span>
        </div>
      </div>
    </div>
  )
}